import { ref } from "vue";
import { defineStore } from "pinia";
import { analytics } from "@/services/analytics.service";

export const useAppStore = defineStore("app", () => {
  const showImportPopup = ref(false);
  const showWelcomeVideoPopup = ref(false);
  const showNewWorkspacePopup = ref(false);
  const showAdvancedExportPopup = ref(false);
  const showSharePopup = ref(false);
  const showDeleteAccountPopup = ref(false);
  const showRecordingPopup = ref(false);
  const showMobileRecordSheet = ref(false);
  const showMobileSearchOverlay = ref(false);
  const user = ref(null);

  // Share-related state
  const shareCache = ref(new Map()); // Cache share links by audioFileUUID
  const isCreatingShare = ref(false);

  const setShowNewWorkspacePopup = (value) => {
    console.log("Setting showNewWorkspacePopup to", value);
    showNewWorkspacePopup.value = value;
  };

  const openImportPopup = () => {
    analytics.importButtonClicked();
    showImportPopup.value = true;
  };

  // Share-related methods
  const cacheShareLinks = (audioFileUUID, shares) => {
    shareCache.value.set(audioFileUUID, {
      shares,
      timestamp: Date.now(),
    });
  };

  const getCachedShareLinks = (audioFileUUID) => {
    const cached = shareCache.value.get(audioFileUUID);
    if (!cached) return null;

    // Cache expires after 5 minutes
    if (Date.now() - cached.timestamp > 5 * 60 * 1000) {
      shareCache.value.delete(audioFileUUID);
      return null;
    }

    return cached.shares;
  };

  const clearShareCache = (audioFileUUID = null) => {
    if (audioFileUUID) {
      shareCache.value.delete(audioFileUUID);
    } else {
      shareCache.value.clear();
    }
  };

  return {
    showImportPopup,
    showWelcomeVideoPopup,
    showNewWorkspacePopup,
    showAdvancedExportPopup,
    showSharePopup,
    showDeleteAccountPopup,
    showRecordingPopup,
    showMobileRecordSheet,
    showMobileSearchOverlay,
    user,
    shareCache,
    isCreatingShare,
    setShowNewWorkspacePopup,
    openImportPopup,
    cacheShareLinks,
    getCachedShareLinks,
    clearShareCache,
  };
});
